var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgFooterSocialMediaLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7FF1AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4768 29H11.3304V15.647H15.4768V29ZM13.4013 13.8256C12.0754 13.8256 11 12.7273 11 11.4014C11 10.7645 11.253 10.1537 11.7033 9.70335C12.1537 9.253 12.7645 9 13.4013 9C14.0382 9 14.649 9.253 15.0993 9.70335C15.5497 10.1537 15.8027 10.7645 15.8027 11.4014C15.8027 12.7273 14.7268 13.8256 13.4013 13.8256ZM30.9955 29H26.858V22.4999C26.858 20.9507 26.8268 18.9641 24.7022 18.9641C22.5464 18.9641 22.2161 20.6471 22.2161 22.3882V29H18.0741V15.647H22.0509V17.4685H22.1089C22.6625 16.4194 24.0147 15.3122 26.0321 15.3122C30.2286 15.3122 31 18.0756 31 21.665V29H30.9955Z",
    fill: "#1C2284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFooterSocialMediaLinkedin);
export default __webpack_public_path__ + "static/media/SvgFooterSocialMediaLinkedin.d9e5f0c92e32fd5a56fadad05b30052a.svg";
export { ForwardRef as ReactComponent };